<div class="container-main">
  <h3 class="bold">FEEDBACK CHALLENGES</h3>
  <div class="sub-menu__container">
    <app-button [ngClass]="completeBtnClass" classes="secondary small" text="COMPLETE" (onClick)="loadTab(true)"></app-button>
    <app-button [ngClass]="incompleteBtnClass" classes="secondary small" text="INCOMPLETE" (onClick)="loadTab(false)"></app-button>
    <p-dropdown
      *ngIf="!isComplete"
      class="sub-menu__state-filter"
      [options]="stateFilterOptions"
      [(ngModel)]="stateFilter"
      (onChange)="applyStateFilter()"
      placeholder="Days Left: All"
      dropdownIcon="pi pi-caret-down">
    </p-dropdown>
  </div>
  <div class="sub-menu__export">
    <app-button classes="secondary small" text="Export All" (onClick)="exportAll()"></app-button>
  </div>

  <app-basic-grid
    class="grids-display"
    [configuration]="gridConfiguration"
    [data]="gridData">

    <ng-template #chaseIdColumn let-rowData>
      <app-chase-grid-chase-id [data]="rowData" [chaseIdUrl]="chaseIdRouteUrl"></app-chase-grid-chase-id>
    </ng-template>

    <ng-template #daysLeftColumn let-rowData>
      <div *ngIf="rowData.daysLeft != null; else noChallengeDate" class="days-left" [ngClass]="daysLeftClass(rowData)" [title]="rowData.reviewDeadlineState">
        <span class="days-left__text">{{ rowData.daysLeftText }}</span>
        <div class="days-left__bar">
          <div class="days-left__fill" [style.width.%]="rowData.reviewDeadlineProgress"></div>
        </div>
      </div>
      <ng-template #noChallengeDate>&mdash;</ng-template>
    </ng-template>

    <ng-template #feedbackStatusColumn let-rowData>
      <span *ngIf="isComplete; else reviewButton">{{ rowData.reviewProgressText }}</span>
      <ng-template #reviewButton>
        <app-button classes="small" text="Review Challenge" (onClick)="reviewChallenge(rowData)"></app-button>
      </ng-template>
    </ng-template>
  </app-basic-grid>
</div>
